import styled from 'styled-components'

export const Label = styled.label`
	display: block;
	margin-bottom: 5px;
	font-size: 16px;
`
